import { useState } from "react";
import { Lock, Loader2 } from "lucide-react";
import Header from "./Header";
import Footer from "./Footer";
import { Input } from "./ui/input";
import { adminLogin } from "../lib/api";
import { toast } from "sonner";

export const AdminLoginGate = ({ onAuthed }) => {
  const [pin, setPin] = useState("");
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!pin) return;
    try {
      setBusy(true);
      // adminLogin now mints an HttpOnly session cookie server-side and
      // flips the local "I'm authed" hint flag on success — no need to
      // persist the raw PIN in sessionStorage anymore.
      await adminLogin(pin);
      toast.success("Welcome back");
      onAuthed();
    } catch (err) {
      const msg = err?.response?.data?.detail || "Invalid PIN";
      toast.error(msg);
      setPin("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div
          data-testid="admin-login-card"
          className="w-full max-w-md rounded-xl border border-slate-200 bg-white p-8"
        >
          <div className="flex items-center gap-2 text-amber-700">
            <Lock size={16} />
            <span className="text-xs uppercase tracking-[0.2em] font-semibold">
              Admin only
            </span>
          </div>
          <h1 className="mt-2 font-display text-3xl font-black text-slate-900 leading-tight">
            Enter your admin PIN
          </h1>
          <p className="mt-2 text-sm text-slate-600">
            This page is private to the Mattoo Consulting team.
          </p>
          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <Input
              data-testid="admin-pin-input"
              type="password"
              placeholder="PIN"
              value={pin}
              onChange={(e) => setPin(e.target.value)}
              autoFocus
              className="h-11 bg-white"
            />
            <button
              type="submit"
              data-testid="admin-pin-submit"
              disabled={!pin || busy}
              className="w-full inline-flex items-center justify-center gap-2 rounded-md bg-slate-900 text-white px-5 py-3 text-sm font-semibold hover:bg-slate-800 disabled:opacity-40 disabled:cursor-not-allowed"
            >
              {busy ? (
                <>
                  <Loader2 className="animate-spin" size={16} /> Checking…
                </>
              ) : (
                "Unlock admin"
              )}
            </button>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default AdminLoginGate;
